import type { PatientProfile, PatientProfileSearchResult } from '../../../contracts';

/**
 * Adapt a `PatientProfileSearchResult` (the find-or-link search response)
 * to the legacy `PatientProfile` shape that `useMutateLinkSessionsToPatientProfile`,
 * `useMutateUnlinkSessionsToPatientProfile`, and the link/unlink toasts expect.
 *
 * Only the fields the legacy mutations and surfaces actually read are copied
 * over; everything else stays undefined. `managed_by_user_ref_id` is copied for
 * analytics: `patient_linked` derives `patient_is_own` from it, and a peer found
 * through directory search is on no cached roster to fall back to (COLAB-422).
 * This is a controlled adapter rather
 * than an `as unknown as` cast so a future change to either schema fails the
 * build instead of silently skipping a needed field.
 */
export function toLegacyPatientProfile(
  result: PatientProfileSearchResult
): PatientProfile {
  // `PatientProfile` does not declare the manager ref, so the assertion names
  // it: without that, the extra key makes the literal non-comparable.
  return {
    id: result.id,
    source: result.source,
    first_name: result.first_name,
    last_name: result.last_name,
    birth_date: result.birth_date,
    gender: result.gender,
    demographic_string: result.demographic_string,
    managed_by_user_ref_id: result.managed_by_user_ref_id,
  } as PatientProfile & { managed_by_user_ref_id?: string | null };
}
